var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',_vm._g({attrs:{"height":"24","width":"24","xmlns":"http://www.w3.org/2000/svg"}},_vm.$listeners),[_c('path',{attrs:{"d":"M20 4a1 1 0 1 0-2 0v10H6.414l3.293-3.293a1 1 0 0 0-1.414-1.414l-5 5a1 1 0 0 0 0 1.414l5 5a1 1 0 0 0 1.414-1.414L6.414 16H18a2 2 0 0 0 2-2z","fill-rule":"evenodd"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }